const { Bookmark, Check } = require("@mui/icons-material");
const { Box } = require("@mui/material");

export default function BookmarkWithInnerIcon({className, style, bookmarkColor="primary", bookmarkSize=18, InnerIcon, innerColor, innerSize, onClick}) {
  return (
    <Box
      className={className}
      style={style}
      onClick={onClick}
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }}
    >
      <Bookmark sx={{color: bookmarkColor, fontSize: bookmarkSize}} />

      <InnerIcon
        sx={{
          position: 'absolute',
          fontSize: innerSize,
          color: innerColor,
        }}
      />
    </Box>
  );
}